import { Route, Routes, Outlet } from "react-router-dom";
import LoginScreen from "../screens/Authentication/User/LoginScreen";
import UserScreen from "../screens/User";

const routes = [
  {
    path: "/login",
    element: <LoginScreen />,
  },
  {
    path: "/user/*",
    element: <UserScreen />,
  },
];

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return (
    <>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
        <Route path="*" element={null} />
      </Routes>
      <Outlet />
    </>
  );
};
